import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@material-ui/core';
import GridContainer from '../GridContainer';
import TextfieldWrapper from '../FormikWrappers/TextfieldWrapper';
import CheckBoxWrapper from '../FormikWrappers/CheckboxWrapper';
import { useDispatch } from 'react-redux';
import '../../pages/Users/NewUser/newuser.scss';

const EditPdfDialog = ({ open, handleClose, handleOk, item, onUpdate }) => {
  const formRef = useRef();
  const dispatch = useDispatch();

  const [initialFormState, setInitialFormState] = useState({
    title: '',
    isActive: true
  });

  useEffect(() => {
    if (item?.id) {
      setInitialFormState({
        title: item.title,
        isActive: item.isActive
      });
    }
  }, [item]);

  return (
    <Dialog maxWidth="sm" fullWidth onClose={handleClose} open={open}>
      <DialogTitle>Update</DialogTitle>
      <DialogContent dividers>
        <Formik
          innerRef={formRef}
          initialValues={{ ...initialFormState }}
          validationSchema={Yup.object({ title: Yup.string().required('Title is required') })}
          enableReinitialize
          onSubmit={(values) => dispatch(onUpdate(item.id, values, handleOk))}
        >
          {() => (
            <Form>
              <GridContainer className="newuser__container">
                <Grid item xs={12}>
                  <TextfieldWrapper name="title" label="Title" />
                </Grid>
                <Grid item xs={12}>
                  <CheckBoxWrapper name="isActive" label="Active" />
                </Grid>
              </GridContainer>
            </Form>
          )}
        </Formik>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => formRef.current.submitForm()} color="primary">
          Save
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

EditPdfDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleOk: PropTypes.func,
  item: PropTypes.object,
  onUpdate: PropTypes.func.isRequired
};

export default EditPdfDialog;
